import type { GetAdminV1OrgMediaParams } from '@nucleus-commerce/api-client/admin';

export const mediaKeys = {
  all: ['org', 'media'] as const,
  lists: () => [...mediaKeys.all, 'list'] as const,
  list: (params: Omit<GetAdminV1OrgMediaParams, 'cursor'>) =>
    [...mediaKeys.lists(), params] as const,
  details: () => [...mediaKeys.all, 'detail'] as const,
  detail: (id: string) => [...mediaKeys.details(), id] as const,
  folders: () => [...mediaKeys.all, 'folders'] as const,
};
